/**
 * @name dataExtract
 * @description
 * Function to work with the location path of the page
 **/
export default class DataExtract {

    constructor() {}

    /**
     * @name getApplicationJSON
     * @description
     * Extract JSON data from script application/json
     * @return
     * { object } JSON object
     */
    getApplicationJSON(id) {
        return document.getElementById(id) ? JSON.parse(document.getElementById(id).innerText) : null;
    }

    /**
     * @name getItemprop
     * @description
     * Extract content data from itemprop elements
     * @return
     * { array } Array with content value
     */
    getItemprop(name) {
        let els = document.querySelectorAll('[itemprop]'),
            data = [];
        if(els.length != 0){
            for (let i = 0; i < els.length; i++) {
                if(els[i].getAttribute("itemprop") === name){
                    data.push(els[i].getAttribute("content"));
                }
            }
        }
        return data || false;
    }

    /**
     * @name getMetaContent
     *
     * @param {string} name_value The meta tag name value. E.G: value ==> og:image
     * @param {string} get_attr The meta tag attribute that you want get. E.G: content
     * @return {string} The meta tag content value, or null if not found.
     */
    getMetaContent(name_value,  get_attr) {
        let metas = document.getElementsByTagName('meta'),
            re = new RegExp('\\b' + name_value + '\\b', 'i'),
            i = 0,
            mLength = metas.length;

        for (i; i < mLength; i++) {
            if (re.test(metas[i].getAttribute('property'))) return metas[i].getAttribute(get_attr);
        }

        return null;
    };
}